import React, { useContext, useEffect } from 'react';
import { App, Button, Col, Flex, Form, Grid, Input, message, Row, Typography } from 'antd';
import { AxiosError } from 'axios';
import { useMutation } from '@tanstack/react-query';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'antd/lib/form/Form';
import { AreaRestritaUsuarioService, LoginComUsuario, PayloadDePrimeiraSenha } from '../../../Services/Domain/AreaRestrita/UsuarioService';
import { ConfigurarSessaoDoUsuario } from './Acesso.login';
import { SessaoARContext } from '../../Contexts/SessaoContext';
import { notificarErroNaRequisicao, PropriedadesDeNotificacao } from '../../../Utils/Notificacoes';
import { RegrasComunsDeValidacaoDaAR } from '../../Utils/RegrasComunsDeValidacaoDaAR';

export const PainelDePrimeiroAcessoDaEscola: React.FC<{
    credenciais: LoginComUsuario,
    hrefCancelar?: string,
}> = (props) => {
    const { notification } = App.useApp();

    const SessaoAR = useContext(SessaoARContext);
    const navigate = useNavigate()

    interface IFormularioDePrimeiraSenha extends LoginComUsuario { }
    const [form] = useForm<IFormularioDePrimeiraSenha>();

    useEffect(() => {
        form.setFieldValue("usuario", props.credenciais.usuario);
    }, [props.credenciais])

    const mutationPrimeiroAcesso = useMutation({
        mutationFn: async (dados: IFormularioDePrimeiraSenha) => {
            const payload: PayloadDePrimeiraSenha = {
                credenciais: props.credenciais,
                novaSenha: dados.senha
            }

             const service = new AreaRestritaUsuarioService();
             await service.configurarPrimeiraSenhaDaEscola(payload);
             return service.logar({
                usuario: props.credenciais.usuario,
                senha: dados.senha
             })
        },
        onSuccess: (data) => {
            ConfigurarSessaoDoUsuario(data.data, SessaoAR?.setSessao);
            notification.open({
                ...PropriedadesDeNotificacao.Sucesso("Senha alterada com sucesso"),
            });

            navigate("/")
            
        },
        onError: (error: AxiosError, valores) => {
            notificarErroNaRequisicao(error);
        }
    });

    return (
        <div>
            <Typography.Paragraph >
                A escola precisa definir sua senha para os acessos posteriores.
            </Typography.Paragraph>

            <Form<IFormularioDePrimeiraSenha>
                form={form}
                onFinish={(valores) => mutationPrimeiroAcesso.mutate(valores)}
                autoComplete="off"
                layout="vertical"
            >
                <Row gutter={8}>
                    <Col xs={24}>
                        <Form.Item<IFormularioDePrimeiraSenha>
                            label="Acesso"
                            name="usuario"
                            required
                        >
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col xs={24}>
                        <Form.Item<IFormularioDePrimeiraSenha>
                            name="senha"
                            label="Nova senha"
                            rules={RegrasComunsDeValidacaoDaAR.Senha}
                        >
                            <Input.Password placeholder="Nova senha"></Input.Password>
                        </Form.Item>
                    </Col>

                    <Col xs={24}>
                        <Form.Item style={{ marginTop: "1em" }}>
                            <Flex align='center' vertical>
                                <Button type="primary" htmlType="submit" loading={mutationPrimeiroAcesso.isPending} block>Salvar</Button>
                            </Flex>
                        </Form.Item>
                    </Col>

                </Row>
            </Form>

        </div>
    );
}
